export default __webpack_public_path__ + "static/media/Bg4-2.fdd083b5.png";